<template>
  <strong>
    <v-chip
      :color="payload.color"
      :text-color="payload.textColor"
      class="text-uppercase"
      label
    >
      {{ payload.label }}
    </v-chip>
  </strong>
</template>

<script>
import DataTableChipColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableChipColumn.vue';
import ChipColors from '@/app/arch/enums/ChipColors';

export default {
  name: 'ClientTypePerson',
  extends: DataTableChipColumnVue,
  data: () => ({
    status: [
      {
        value: 'NaturalPerson',
        text: 'Pessoa física',
        ...ChipColors.danger,
      },
      {
        value: 'LegalPerson',
        text: 'Pessoa jurídica',
        ...ChipColors.warning,
      },
    ],
  }),
};
</script>
